module.exports = __webpack_public_path__ + "static/media/iconCalendar.1a5ac644.svg";